var HelperView = require('./helper.js');
var AnalyticsDecorate = require('../../../../analytics/decorate');
var UserInfoFactory = require('../../../../factory/user-info');
var PageThumbnailFactory = require('../../../../factory/page-thumbnail');
var EditorFacade = require('../../../../facade/editor/editor');

import desygnerApi from '../../../../factory/desygner-api';

var template = require('./template.hbs');
var nocontentTemplate = require('./nocontent-template.hbs');

module.exports = AnalyticsDecorate(require('../../analytics/versions'), Backbone.View.extend({
  events: {
    'click a[data-action="loadversion"]': 'loadVersionEvent'
  },

  loadVersionEvent: function (event) {
    EditorFacade.handle('page', 'load_version', {
      version_id: $(event.currentTarget).attr('data-version')
    });
  },

  initialize: function () {
    _.bindAll(this, 'onVersions');
    this.tool = INKIVE.Tool.getInstance();

    UserInfoFactory.get().then(_.bind(function (userInfo) {
      this.canUse = hasRole('ROLE_PREMIUM')
        || INKIVE.Helpers.projectIsLinkedToRestrictions();

      this.canUse || this.initHelper();

      function hasRole (role) {
        return _(userInfo['roles']).contains(role);
      }
    }, this));
  },

  show: function () {
    this.$el.find('.antiscroll-inner').css('height', 'auto');
    this.$el.find('.tab-content').empty();
    this.$el.css('right', '');
    this.$el.css('left', 15);

    this.canUse || this.helperView.toggle(true);
    INKIVE.Modal.loader(this.$el.find('.tab-content'));

    const endpoint = `business/projects/${INKIVE.C.BOOK.encodedId}` +
      `/pages/${INKIVE.Tool._current_design_id}/versions`;

    desygnerApi.get(endpoint).then(versions => this.onVersions(versions));
  },

  onVersions: function (results) {
    var $container = this.$el.find('.tab-content');
    var $subMenu = $container.closest('.ui-dropdown-content[data-id="versions"]');
    $subMenu.find('.content').addClass('active');

    if (results && results.length > 0) {
      this.replaceClientRenderedImages(results);

      $subMenu.find('.versions-title-hascontent').addClass('active');
      $subMenu.find('.versions-title-nocontent').removeClass('active');

      _.each(results, _.bind(this.appendVersion, this, $container));
    } else {
      $container.append(nocontentTemplate());
    }

    if ($subMenu.find('.no-version-icon-container').is(':visible')) {
      $subMenu.find('.antiscroll-inner').addClass('no-version-saved');
    }

    INKIVE.Modal.loaderClose($container);

    this.$el.find('.antiscroll-wrap').antiscroll({
      autoHide: false,
      height: this.$el.height() - 40
    });
  },

  replaceClientRenderedImages: function (backendVersions) {
    _.each(PageThumbnailFactory.versions, function (clientVersion) {
      var lowestDifference;

      if (clientVersion.designId === INKIVE.Tool._current_design_id) {
        _.each(backendVersions, function (backendVersion) {
          var timestampDifference = Math.abs(clientVersion.timeStamp - backendVersion.creationTime);

          if (!lowestDifference || timestampDifference < lowestDifference) {
            backendVersion.base64 = clientVersion.base64;
            lowestDifference = timestampDifference;
          }
        });
      }
    });
  },

  appendVersion: function ($container, data) {
    var $item = $(template({
      version: data,
      time_since: this.timeSince(data.secondsAgo)
    }));

    $container.append($item);

    var bucket = (INKIVE.C.IS_DEV || INKIVE.C.IS_QA)
      ? 'singapore.inkive.com'
      : 'virginia.inkive.com';

    var protocol = bucket === 'singapore.inkive.com' ? 'http' : 'https';
    var $img = $item.find('img');
    var src = protocol === 'http'
      ? 'http://' + bucket + '/' + data.previewName
      : 'https://s3.amazonaws.com/' + bucket + '/' + data.previewName;

    src = data.base64 ? data.base64 : src;

    INKIVE.Helpers.imageLoader(src, function (status, img) {
      $img.attr('src', status === INKIVE.C.Status.success
        ? img.src : INKIVE.C.THUMB_NOCOVER
      );

      $img.removeClass('empty');
    });
  },

  initHelper: function () {
    var $helperView = $('<div>');
    this.$el.append($helperView);
    this.helperView = new HelperView({ el: $helperView});

    this.helperView.on('toggle', _.bind(function (value) {
      this.$el.find('.content').toggleClass('blur', value);
    }, this));
  },

  timeSince: function (seconds) {
    var t = INKIVE.TranslateHelper.translate;
    var minutes = seconds / 60;
    var hours = minutes / 60;
    var days = hours / 24;
    var years = days / 365;

    return t('time_ago.prefix') + ' ' + (
      seconds < 45 && t('time_ago.seconds') ||
      seconds < 90 && t('time_ago.minute') ||
      minutes < 45 && t('time_ago.minutes', { time: Math.round(minutes) }) ||
      minutes < 90 && t('time_ago.hour') ||
      hours < 24 && t('time_ago.hours', { time: Math.round(hours) }) ||
      hours < 42 && t('time_ago.day') ||
      days < 30 && t('time_ago.days', { time: Math.round(days) }) ||
      days < 45 && t('time_ago.month') ||
      days < 365 && t('time_ago.months', { time: Math.round(days / 30) }) ||
      years < 1.5 && t('time_ago.year') ||
      t('time_ago.years', { time: Math.round(years) })
    ) + ' ' + t('time_ago.suffix');
  }
}));
